import { createContext, useContext, useEffect, useState } from "react";
import { jwtDecode } from 'jwt-decode';
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
const location = useLocation();

useEffect(() => {
  let logoutTimer;

  if (token) {
    try {
      const decoded = jwtDecode(token);
      const isExpired = decoded.exp * 1000 < Date.now();

      if (isExpired) {
        toast.error("Session expired. Please login again.");
        handleLogout();

        // ✅ Only redirect to admin login if already on admin route
        if (location.pathname.startsWith("/admin")) {
          navigate("/admin/login");
        }
      } else {
        setUser(decoded);
        setIsAdmin(decoded.role === "admin");

        const timeLeft = decoded.exp * 1000 - Date.now();

        logoutTimer = setTimeout(() => {
          toast.error("Session expired. Please login again.");
          handleLogout();
          if (location.pathname.startsWith("/admin")) {
            navigate("/admin/login");
          }
        }, timeLeft);
      }
    } catch (err) {
      console.error("Invalid token:", err);
      toast.error("Invalid token. Please login again.");
      handleLogout();
      if (location.pathname.startsWith("/admin")) {
        navigate("/admin/login");
      }
    }
  }

  return () => {
    if (logoutTimer) clearTimeout(logoutTimer);
  };
}, [token, location.pathname, navigate]);



  const handleLogout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("isAdmin");
    setToken("");
    setIsAdmin(false);
    setUser(null);
  };
  


  return (
    <AuthContext.Provider value={{ token, isAdmin, user, setToken, setIsAdmin, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
